var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-1"},[_c('CompoundFormInputFields',{attrs:{"refName":_vm.refName,"field":_vm.field,"obj":_vm.obj,"clickToAddFuncArgs":[
      ("add-" + _vm.refName),
      _vm.field.split,
      _vm.field.inputProcessFunc
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }